export default __webpack_public_path__ + "static/media/Aura-Egg__39.d16d0fde.png";